import { useState } from "react";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";

export function PartnerAddDriver({ onAdded }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!form.name || !form.email) { toast.error("Nome ed email obbligatori"); return; }
    setBusy(true);
    try {
      await api.post("/partners/drivers", form);
      toast.success("Autista creato e invitato via email");
      setOpen(false); setForm({ name: "", email: "", phone: "" }); onAdded?.();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-blue-900 hover:bg-blue-800" data-testid="partner-add-driver-btn"><UserPlus size={16} className="mr-1.5" /> Aggiungi autista</Button>
      </DialogTrigger>
      <DialogContent data-testid="partner-add-driver-dialog">
        <DialogHeader><DialogTitle className="font-display">Aggiungi autista</DialogTitle></DialogHeader>
        <div className="space-y-3 py-1">
          <div className="space-y-1.5"><Label>Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="pad-name" /></div>
          <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="pad-email" /></div>
          <div className="space-y-1.5"><Label>Telefono</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="pad-phone" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
          <Button onClick={submit} disabled={busy} className="bg-blue-900 hover:bg-blue-800" data-testid="pad-submit">{busy ? "..." : "Crea e invita"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
